import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  LocationFinderModalContainer, type LocationFinderModalContainerProps,
} from './locationFinderModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    LocationFinder: LocationFinderModalContainerProps;
  }
}

modalRenderer.register('LocationFinder', LocationFinderModalContainer);
